var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollapseButtonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.52883 6.9715C7.65883 7.1015 7.8295 7.16683 8.00017 7.16683C8.17083 7.16683 8.3415 7.1015 8.4715 6.9715L11.8048 3.63817C12.0655 3.3775 12.0655 2.95617 11.8048 2.6955C11.5442 2.43483 11.1228 2.43483 10.8622 2.6955L8.00017 5.5575L5.13817 2.6955C4.8775 2.43483 4.45617 2.43483 4.1955 2.6955C3.93483 2.95617 3.93483 3.3775 4.1955 3.63817L7.52883 6.9715Z",
    fill: "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8622 14.3048C10.9922 14.4348 11.1628 14.5002 11.3335 14.5002C11.5042 14.5002 11.6748 14.4348 11.8048 14.3048C12.0655 14.0442 12.0655 13.6228 11.8048 13.3622L8.4715 10.0288C8.21083 9.76817 7.7895 9.76817 7.52883 10.0288L4.1955 13.3622C3.93483 13.6228 3.93483 14.0442 4.1955 14.3048C4.45617 14.5655 4.8775 14.5655 5.13817 14.3048L8.00017 11.4428L10.8622 14.3048Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseButtonIcon);
export default __webpack_public_path__ + "static/media/Collapse_ButtonIcon.87235b6919d97670af6235d77d9bc651.svg";
export { ForwardRef as ReactComponent };